import React from "react";

import { EmptyObject } from "../global.types";
import { TableStorage } from "../model/TableStorage";
import BindingContext from "../odata/BindingContext";
import { IFormDef, IProps as IFormProps } from "../views/formView/Form";
import { ITableViewBaseProps } from "../views/table/TableView";
import { ISplitPageTableDef } from "../views/table/TableView.utils";
import DialogPageBase, { IDialogPageBaseProps } from "./DialogPageBase";
import { IProps as ISplitPageProps, SplitPage } from "./SplitPage";

export interface IProps extends IDialogPageBaseProps {
    tableView?: React.ComponentType<ITableViewBaseProps>;
    tableViewProps?: any;
    initializeStorage?: (storage: TableStorage) => void;
    formProps?: Partial<IFormProps>;
    hasPreview?: boolean;
}

export interface ISplitPagePaneData<Type = IFormDef | ISplitPageTableDef> {
    bc?: BindingContext;
    def?: Type;
    entitySet?: string;
}

export default class DialogPage<P extends IProps, S = EmptyObject> extends DialogPageBase<P, S, ISplitPageProps> {

    getMandatoryProps(): ISplitPageProps & { key: string } {
        const isEditable = this.detailData?.bc?.isNew();
        this.masterData.entitySet = this.getEntitySet();

        return {
            key: this.context.getCompany().Id,
            // need to duplicate wrapper object for correct prevProps in splitpage
            masterData: { ...this.masterData },
            detailData: { ...this.detailData },
            t: this.t,
            tableView: this.props.tableView,
            rootStorage: this.props.rootStorage,
            pageViewMode: isEditable ? undefined : this.props.pageViewMode,
            formProps: {
                customFooterButtons: isEditable ? undefined : this.props.customFooterButtons,
                hideBreadcrumbs: true,
                shouldHideAuditTrail: true,
                isSimple: true,
                ...this.props.formProps,
            },
            tableViewProps: this.props.tableViewProps,
            initializeStorage: this.props.initializeStorage,
            isInDialog: true,

            ...this.getMandatoryChildParentProps(),

            onRowSelect: this.handleRowSelect,
            onCloseDetail: this.handleCloseDetail,
            onAfterSave: this.handleAfterSave
        };
    }

    render() {
        const props = this.getMandatoryProps();

        return (
            <SplitPage onAddDetail={this.handleAddDetail}
                       {...props}
                       hasPreview={this.props.hasPreview}
                       key={props?.key}
            />
        );
    }
}
